import { httpClient } from 'utils/httpClient';
import {
  GenerarNominaPayload, AprobarNominaPayload, NominaResponse,
} from 'types/nomina.types';

export const nominaService = {
  async listarPorAnio(anioEscolarId: number): Promise<NominaResponse[]> {
    try {
      return await httpClient.get<NominaResponse[]>(`/nominas-matricula?anioEscolarId=${anioEscolarId}`);
    } catch { return []; }
  },
  async getBySeccion(seccionId: number, anioEscolarId: number): Promise<NominaResponse | null> {
    try {
      return await httpClient.get<NominaResponse>(`/nominas-matricula/seccion/${seccionId}?anioEscolarId=${anioEscolarId}`);
    } catch { return null; }
  },
  async generar(payload: GenerarNominaPayload): Promise<NominaResponse> {
    return httpClient.post<NominaResponse>('/nominas-matricula/generar', payload);
  },
  async aprobar(id: number, payload: AprobarNominaPayload): Promise<NominaResponse> {
    return httpClient.put<NominaResponse>(`/nominas-matricula/${id}/aprobar`, payload);
  },
  async enviarUgel(id: number): Promise<NominaResponse> {
    return httpClient.put<NominaResponse>(`/nominas-matricula/${id}/enviar-ugel`, {});
  },
  async rectificar(id: number, observaciones?: string): Promise<NominaResponse> {
    return httpClient.put<NominaResponse>(`/nominas-matricula/${id}/rectificar`, observaciones ? { observaciones } : {});
  },
};
